import './Navbar.scss';
import React from 'react';
import GGLoaderView from '../../UtilityComponents/GGLoaderView/GGLoaderView';
import SnackBar from "../../UtilityComponents/SnackBar/SnackBar";
import NotificationPanel from '../../PageComponents/NotificationWindow/NotificationPanel/NotificationPanel';
import FavouritesPanel from '../../PageComponents/FavouritesWindow/FavouritesPanel/FavouritesPanel';
import { useNavbarController, UserStateEnum } from './hooks/useNavbarController';
import BuyerNavbar from './components/desktop/BuyerNavbar';
import SellerNavbar from './components/desktop/SellerNavbar';
import GuestNavbar from './components/desktop/GuestNavbar';
import MobileNavbar from './components/mobile/MobileNavbar';
import ContactUsModal from './components/shared/ContactUsModal';

interface NavBarProps {
  useScrollVersion?: Boolean;
  whiteText?: Boolean;
}

const Navbar = ({ useScrollVersion, whiteText }: NavBarProps) => {
  const {
    scrolling,
    useWhiteText,
    userState,
    showMenuPopup,
    openNotificationPanel,
    setOpenNotificationPanel,
    openFavPanel,
    setOpenFavPanel,
    showLoader,
    buyer,
    navbarTopFiveNotifications,
    unreadNotificationCount,
    unreadMsgCount,
    tab,
    setTab,
    formData,
    openModal,
    snackBarRef,
    snackBarParams,
    location,
    performSignout,
    menuPopupHandler,
    handleFavouritesClick,
    handleNotificationClick,
    handleOrderClick,
    handleContactUsClick,
    handleFormData,
    submitFeedback,
    handleClose,
    scrollTop,
    mobileNaveStateToggle,
    navigate,
  } = useNavbarController(useScrollVersion, whiteText);

  return (
    <>
      {showLoader && <GGLoaderView />}
      <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />

      {/* Contact Us Modal */}
      <ContactUsModal
        open={openModal}
        tab={tab}
        setTab={setTab}
        formData={formData}
        onFormChange={handleFormData}
        onSubmit={submitFeedback}
        onClose={handleClose}
      />

      {/* Desktop Navbar - Buyer */}
      {userState === UserStateEnum.Client && (
        <>
          <BuyerNavbar
            scrolling={!!scrolling}
            useWhiteText={!!useWhiteText}
            buyer={buyer || undefined}
            unreadMsgCount={unreadMsgCount}
            unreadNotificationCount={unreadNotificationCount}
            navbarTopFiveNotifications={navbarTopFiveNotifications}
            showMenuPopup={showMenuPopup}
            onLogoClick={scrollTop}
            onFavouritesClick={handleFavouritesClick}
            onMessagesClick={() => navigate("/my-messages")}
            onMenuPopupHandler={menuPopupHandler}
            onNotificationClick={handleNotificationClick}
            onMyProfileClick={() => navigate("/my-profile")}
            onOrdersClick={handleOrderClick}
            onContactUsClick={handleContactUsClick}
            onSignOutClick={performSignout}
          />
          <NotificationPanel openPanel={openNotificationPanel} setOpenPanel={setOpenNotificationPanel} />
          <FavouritesPanel openPanel={openFavPanel} setOpenPanel={setOpenFavPanel} />
        </>
      )}

      {/* Desktop Navbar - Seller */}
      {userState === UserStateEnum.Freelancer && (
        <>
          <SellerNavbar
            scrolling={!!scrolling}
            useWhiteText={!!useWhiteText}
            buyer={buyer || undefined}
            unreadMsgCount={unreadMsgCount}
            unreadNotificationCount={unreadNotificationCount}
            navbarTopFiveNotifications={navbarTopFiveNotifications}
            showMenuPopup={showMenuPopup}
            onLogoClick={scrollTop}
            onMessagesClick={() => navigate("/my-messages")}
            onDashboardClick={() => navigate('/freelancer-dashboard/')}
            onMenuPopupHandler={menuPopupHandler}
            onNotificationClick={handleNotificationClick}
            onMyProfileClick={() => navigate("/my-profile")}
            onFavouritesClick={handleFavouritesClick}
            onOrdersClick={handleOrderClick}
            onContactUsClick={handleContactUsClick}
            onSignOutClick={performSignout}
          />
          <NotificationPanel openPanel={openNotificationPanel} setOpenPanel={setOpenNotificationPanel} />
          <FavouritesPanel openPanel={openFavPanel} setOpenPanel={setOpenFavPanel} />
        </>
      )}

      {/* Desktop Navbar - Guest */}
      {userState === UserStateEnum.LoggedOut && (
        <GuestNavbar
          scrolling={!!scrolling}
          useWhiteText={!!useWhiteText}
          onLogoClick={scrollTop}
        />
      )}

      {/* Mobile Navbar */}
      <MobileNavbar
        userState={userState}
        buyer={buyer || undefined}
        unreadMsgCount={unreadMsgCount}
        unreadNotificationCount={unreadNotificationCount}
        openNotificationPanel={openNotificationPanel}
        openFavPanel={openFavPanel}
        currentPath={location.pathname}
        onLogoClick={scrollTop}
        onToggle={mobileNaveStateToggle}
        onNavigate={navigate}
        onMyProfileClick={() => navigate("/my-profile")}
        onFavouritesClick={handleFavouritesClick}
        onOrdersClick={handleOrderClick}
        onContactUsClick={handleContactUsClick}
        onSignOutClick={performSignout}
        onNotificationClick={handleNotificationClick}
      />
    </>
  );
};

export default Navbar;

